import register from 'react-lib/dist/behavior-es';

import { inventoriesMessages, inventoriesReducer, inventorySagas } from './inventories';
import {
  chemicalProductsMessages,
  chemicalProductSagas,
  chemicalProductsReducer,
} from './chemicalProducts';
import { initMessages, initReducer } from './init';
import { personSagas } from './persons';
import { casNumberSagas, casNumbersMessages, casNumbersReducer } from './casNumbers';
import { lazyAutocompleteReducer } from './lazyAutocomplete';
import { unNumbersReducer, unNumberSagas, unNumbersMessages } from './unNumbers';
import { equipmentsReducer, equipmentSagas, equipmentsMessages } from './equipments';
import { locationsReducer, locationSagas, locationsMessages } from './locations';
import {
  hazardStatementsReducer,
  hazardStatementSagas,
  hazardStatementsMessages,
} from './hazardStatements';
import { risksReducer, riskSagas, risksMessages } from './risks';
import { commonReducer, commonSagas } from './common';
import { filterSagas, filterReducer } from './filter';
import { dataViewSagas, dataViewReducer, dataVieMessages } from './dataview';
import {
  inventoriesHistoryMessages,
  inventoriesHistoryReducer,
  inventoryHistorySagas,
} from './inventories/history';
import {
  chemicalProductsHistoryReducer,
  chemicalProductHistorySagas,
  chemicalProductsHistoryMessages,
} from './chemicalProducts/history';
import { gisModalReducer } from './gisModal';
import { sdsSearchModalReducer } from './sdsSearchModal';
import { changesNotificationModalReducer } from './changesNotificationModal';
import { reportSagas, reportsMessages, reportsReducer } from './reports';
import { batchUpdateReducer, batchUpdateSagas } from './batchUpdate';
import { risksResultReducer } from './risksResult';
import { titlesReducer } from './titles';
import { genericDetailsMessages, genericDetailsReducer } from './genericDetails';
import {
  accessRequestSagas,
  accessRequestsMessages,
  accessRequestsReducer,
} from './accessRequests';
import { supplierSagas, suppliersMessages, suppliersReducer } from './suppliers';
import {
  compareRowsModalMessages,
  compareRowsModalReducer,
  compareRowsModalSagas,
} from './compareRowsModal';
import { lmsCourseSagas, lmsCoursesReducer } from './lmsCourses';
import { dataPrivacyReducer } from './dataPrivacy';

export const [reducers, rootSaga] = register(
  {
    inventories: inventoriesReducer,
    inventoriesHistory: inventoriesHistoryReducer,
    lazyAutocomplete: lazyAutocompleteReducer,
    casNumbers: casNumbersReducer,
    chemicalProducts: chemicalProductsReducer,
    chemicalProductsHistory: chemicalProductsHistoryReducer,
    unNumbers: unNumbersReducer,
    equipments: equipmentsReducer,
    locations: locationsReducer,
    hazardStatements: hazardStatementsReducer,
    risks: risksReducer,
    risksResult: risksResultReducer,
    common: commonReducer,
    filter: filterReducer,
    dataView: dataViewReducer,
    gisModal: gisModalReducer,
    sdsSearchModal: sdsSearchModalReducer,
    init: initReducer,
    changesNotificationModal: changesNotificationModalReducer,
    reports: reportsReducer,
    batchUpdate: batchUpdateReducer,
    titles: titlesReducer,
    genericDetails: genericDetailsReducer,
    accessRequests: accessRequestsReducer,
    suppliers: suppliersReducer,
    compareRowsModal: compareRowsModalReducer,
    lmsCourses: lmsCoursesReducer,
    dataPrivacy: dataPrivacyReducer,
    // add reducers here
  },
  [
    inventoriesMessages,
    initMessages,
    chemicalProductsMessages,
    chemicalProductsHistoryMessages,
    locationsMessages,
    dataVieMessages,
    reportsMessages,
    casNumbersMessages,
    equipmentsMessages,
    hazardStatementsMessages,
    inventoriesHistoryMessages,
    risksMessages,
    unNumbersMessages,
    genericDetailsMessages,
    accessRequestsMessages,
    suppliersMessages,
    compareRowsModalMessages,
    // add messages reducers here
  ],
  [
    ...inventorySagas,
    ...inventoryHistorySagas,
    ...personSagas,
    ...casNumberSagas,
    ...chemicalProductSagas,
    ...chemicalProductHistorySagas,
    ...unNumberSagas,
    ...equipmentSagas,
    ...locationSagas,
    ...hazardStatementSagas,
    ...riskSagas,
    ...filterSagas,
    ...dataViewSagas,
    ...reportSagas,
    ...batchUpdateSagas,
    ...commonSagas,
    ...accessRequestSagas,
    ...supplierSagas,
    ...compareRowsModalSagas,
    ...lmsCourseSagas,
    // add sagas here
  ]
);
